import {Injectable} from '@angular/core';

import {Subject} from 'rxjs/Subject';

import {AuthService} from './auth.service';
import {LogService} from './log.service';


@Injectable()
export class TabService {
	constructor (
		private authService: AuthService,
		private log: LogService
	) {
		// this.reviewerOnlySource.asObservable()
		// 	.subscribe((reviewerOnlyChecked) => {
		// 		console.log('from tab servcie! reviewerOnlyChecked');
		// 		console.log(reviewerOnlyChecked);
		// 		this.reviewerOnly = reviewerOnlyChecked;
		// 		this.buildTabs();
		// 	});


		this.pinMenuBarSource.asObservable()
			.subscribe((pinMenuBarChecked) => {
				console.log('from tab servcie! pinMenuBarChecked');
				console.log(pinMenuBarChecked);
				this.pinMenuBar = pinMenuBarChecked;
			});

		this.showTwoRowMenuBarSource.asObservable()
			.subscribe((showTwoRowMenuBarChecked) => {
				// console.log('from tab servcie! showTwoRowMenuBarChecked');
				// console.log(showTwoRowMenuBarChecked);
				this.showTwoRowMenuBar = showTwoRowMenuBarChecked;
			});

		// console.log('start ctor');
		this.buildTabs();
		// console.log('end ctor');
	}


	permissionsString = '';

	// reviewerOnly = true;
	// reviewerOnlySource = new Subject<any>();


	pinMenuBar = false;
	pinMenuBarSource = new Subject<any>();

	showTwoRowMenuBar = false;
	showTwoRowMenuBarSource = new Subject<any>();

	newTabsSource = new Subject<any>();



	pinSideNav = true;
	pinSearch = true;
	pinScrollToTop = true;
	showWebsiteTabs = true;
	submissionsAutoLogin = true;


	siteIndex: number|null = null;
	reviewerIndex: number|null = null;
	reviewerProfileIndex: number|null = null;
	volunteerIndex: number|null = null;
	volunteerApplicationIndex: number|null = null;



	navTabsFullSet = {
		firstIndex: 0,
		firstTabs: [{
			name: 'SITE',
			secondTab: {
				index: 0,
				tabs: [
					{name: 'HOME', link: 'site/home'},
					// {name: 'STORY', link: 'site/story'},
					// {name: 'FEATURES', link: 'site/features'},
					// {name: 'PRICING', link: 'site/pricing'},
					{name: 'GET STARTED', link: 'site/getstarted'},
					// {name: 'CONTACT', link: 'site/contact'}
				]
			}
		}, {
			name: 'ORGANIZATION',
			secondTab: {
				index: 0,
				tabs: [
					// {name: 'SUMMARY', link: 'dashboard/summary'},
					// {name: 'SEARCH', link: 'dashboard/search'},
					// {name: 'CONTACT', link: 'dashboard/contact'},
					// {name: 'COMPANY', link: 'dashboard/company'},
					// {name: 'FILM', link: 'dashboard/film'}
					// {name: 'STORY', link: 'site/story'},
					// {name: 'FEATURES', link: 'site/features'},
					// {name: 'PRICING', link: 'site/pricing'},
					// {name: 'GET STARTED', link: 'site/getstarted'},
					{name: 'SETTINGS', link: 'organization/settings'}
				]
			}
		}, {
			name: 'DASHBOARD',
			secondTab: {
				index: 0,
				tabs: [
					{name: 'SUMMARY', link: 'dashboard/summary'},
					{name: 'SEARCH', link: 'dashboard/search'},
					{name: 'CONTACT', link: 'dashboard/contact'},
					{name: 'COMPANY', link: 'dashboard/company'},
					{name: 'FILM', link: 'dashboard/film'}
					// {name: 'STORY', link: 'site/story'},
					// {name: 'FEATURES', link: 'site/features'},
					// {name: 'PRICING', link: 'site/pricing'},
					// {name: 'GET STARTED', link: 'site/getstarted'},
					// {name: 'CONTACT', link: 'site/contact'}
				]
			}
		}, {
			name: 'FESTIVAL',
			secondTab: {
				index: 0,
				tabs: [
					// {name: 'NEXT UP', link: 'festival/nextup'},
					// {name: 'TICKETS', link: 'festival/tickets'},
					{name: '', link: 'festival/nextup'},
					{name: '', link: 'festival/tickets'},
					// {name: 'ROSE THEATER', link: 'festival/venues'},
					{name: 'CONCIERGE', link: 'festival/concierge'},
					{name: 'BALLOTS', link: 'festival/ballots'},
					{name: 'PROGRAM', link: 'festival/program'},
					{name: 'FILMS', link: 'festival/films'},
					{name: 'FAVORITES', link: 'festival/favorites'},
					// {name: 'TICKETS', link: 'festival/tickets'}
				]
			}
		}, {
			name: 'PROGRAM',
			secondTab: {
				index: 0,
				tabs: [
					{name: 'LINEUP', link: 'program/lineup'},
					{name: 'LETTER', link: 'program/letter'},
					{name: 'BLOCK', link: 'program/block'},
					{name: 'GRID', link: 'program/grid'},
					{name: 'BALLOT', link: 'program/ballot'}
				]
			}
		}, {
			name: 'REVIEWER',
			secondTab: {
				index: 0,
				tabs: [
					{name: 'RESULTS', link: 'reviewer/results'},
					{name: 'TEAM', link: 'reviewer/team'},
					{name: 'CONTENT', link: 'reviewer/content'},
					{name: 'AVAILABLE', link: 'reviewer/available'},
					{name: 'REVIEWING', link: 'reviewer/reviewing'},
					{name: 'REVIEWED', link: 'reviewer/reviewed'},
					{name: 'ALL', link: 'reviewer/all'},
					{name: 'CONTACTS', link: 'common/contacts'},
					// {name: 'SETTINGS', link: 'common/settings'},
					{name: 'PROFILE', link: 'common/profile'},
					{name: 'DEV', link: 'reviewer/dev'}
				]
			}
		}, {
			name: 'VOLUNTEER',
			secondTab: {
				index: 0,
				tabs: [
					{name: 'VOLUNTEER APPLICATION', link: 'volunteer/application'}
				]
			}
		}, {
			name: 'DONATION',
			secondTab: {
				index: 0,
				tabs: [
					{name: 'CONTACT', link: 'donation/contact'},
					{name: 'COMPANY', link: 'donation/company'},
					{name: 'CAMPAIGN', link: 'donation/campaign'}
				]
			}
		},
		// {name: 'PASSES', link: 'reviewer/availalbe'},
		// {name: 'VOLUNTEER', link: 'reviewer/reviewing'},
		// {name: 'SPONSOR', link: 'reviewer/reviewed'},
		// {name: 'DONATION', link: 'reviewer/all'},
		// {name: 'SETTINGS', link: 'profile'},
		{
			name: 'SYSTEM',
			secondTab: {
				index: 0,
				tabs: [
					{name: 'ORGANIZATION', link: 'system/organization'},
					{name: 'EVENT', link: 'system/event'},
					{name: 'EMAIL', link: 'system/email'},
					{name: 'PRECONTENT', link: 'system/precontent'}
				]
			}
		}]
	};







	navTabsSiteOnly = {
		firstIndex: 0,
		firstTabs: [{
			name: 'SITE',
			secondTab: {
				index: 0,
				tabs: [
					{name: 'HOME', link: 'site/home'},
					// {name: 'STORY', link: 'site/story'},
					// {name: 'FEATURES', link: 'site/features'},
					// {name: 'PRICING', link: 'site/pricing'},
					{name: 'GET STARTED', link: 'site/getstarted'},
					// {name: 'CONTACT', link: 'site/contact'}
				]
			}
		}, {
			name: 'FESTIVAL',
			secondTab: {
				index: 0,
				tabs: [
					// {name: 'NEXT UP', link: 'festival/nextup'}
					{name: '', link: 'festival/nextup'}
				]
			}
		}, {
			name: 'VOLUNTEER',
			secondTab: {
				index: 0,
				tabs: [
					{name: 'VOLUNTEER APPLICATION', link: 'volunteer/application'}
				]
			}
		}
		]
	};





/*
	navTabsReviewerOnly = {
		firstIndex: 0,
		firstTabs: [{
			name: 'REVIEWER',
			secondTab: {
				index: 0,
				tabs: [
					{name: 'AVAILABLE', link: 'reviewer/available'},
					{name: 'REVIEWING', link: 'reviewer/reviewing'},
					{name: 'REVIEWED', link: 'reviewer/reviewed'},
					{name: 'ALL', link: 'reviewer/all'},
					{name: 'PROFILE', link: 'common/profile'}
				]
			}
		}],
	};


	navTabsReviewerOnlyWithoutAll = {
		firstIndex: 0,
		firstTabs: [{
			name: 'REVIEWER',
			secondTab: {
				index: 0,
				tabs: [
					{name: 'AVAILABLE', link: 'reviewer/available'},
					{name: 'REVIEWING', link: 'reviewer/reviewing'},
					{name: 'REVIEWED', link: 'reviewer/reviewed'},
					{name: 'PROFILE', link: 'common/profile'}
				]
			}
		}]
	};
*/


	navTabs: any = {};



/*
	navTabs = {
		firstIndex: 3,
		firstTabs: [
			{name: 'SITE'},
			{name: 'FESTIVAL'},
			{name: 'PROGRAM'},
			{name: 'REVIEWER'},
			// {name: 'PASSES', link: 'reviewer/availalbe'},
			// {name: 'VOLUNTEER', link: 'reviewer/reviewing'},
			// {name: 'SPONSOR', link: 'reviewer/reviewed'},
			// {name: 'DONATION', link: 'reviewer/all'},
			// {name: 'SETTINGS', link: 'profile'},
			{name: 'SYSTEM'}
		],
		secondTabs: [
			{
				index: 0,
				tabs: [
					{name: 'HOME', link: 'site/home'},
					{name: 'STORY', link: 'site/story'},
					{name: 'FEATURES', link: 'site/features'},
					{name: 'PRICING', link: 'site/pricing'},
					{name: 'GET STARTED', link: 'site/getstarted'},
					{name: 'CONTACT', link: 'site/contact'}
				]
			},
			{
				index: 0,
				tabs: [
					// {name: 'ROSE THEATER', link: 'festival/venues'},
					{name: 'CONCIERGE', link: 'festival/concierge'},
					{name: 'BALLOTS', link: 'festival/ballots'},
					{name: 'NEXT UP', link: 'festival/nextup'},
					{name: 'PROGRAM', link: 'festival/program'},
					{name: 'FILMS', link: 'festival/films'},
					{name: 'FAVORITES', link: 'festival/favorites'},
					{name: 'TICKETS', link: 'festival/tickets'}
				]
			},
			{
				index: 0,
				tabs: [
					{name: 'LINEUP', link: 'program/lineup'},
					{name: 'LETTER', link: 'program/letter'},
					{name: 'BLOCK', link: 'program/block'},
					{name: 'GRID', link: 'program/grid'},
					{name: 'BALLOT', link: 'program/ballot'}
				]
			},
			{
				index: 0,
				tabs: [
					{name: 'RESULTS', link: 'reviewer/results'},
					{name: 'TEAM', link: 'reviewer/team'},
					{name: 'CONTENT', link: 'reviewer/content'},
					{name: 'AVAILABLE', link: 'reviewer/available'},
					{name: 'REVIEWING', link: 'reviewer/reviewing'},
					{name: 'REVIEWED', link: 'reviewer/reviewed'},
					{name: 'ALL', link: 'reviewer/all'},
					{name: 'CONTACTS', link: 'common/contacts'},
					// {name: 'SETTINGS', link: 'common/settings'},
					{name: 'PROFILE', link: 'common/profile'},
					{name: 'DEV', link: 'reviewer/dev'}
				]
			},
			{
				index: 0,
				tabs: [
					{name: 'ORGANIZATION', link: 'system/organization'},
					{name: 'EVENT', link: 'system/event'},
					{name: 'EMAIL', link: 'system/email'},
					{name: 'PRECONTENT', link: 'system/precontent'}
				]
			}
		]
	};
*/

















/*
	navTabsFullSet = {
		firstIndex: 3,
		firstTabs: [
			{name: 'SITE'},
			{name: 'FESTIVAL'},
			{name: 'PROGRAM'},
			{name: 'REVIEWER'},
			// {name: 'PASSES', link: 'reviewer/availalbe'},
			// {name: 'VOLUNTEER', link: 'reviewer/reviewing'},
			// {name: 'SPONSOR', link: 'reviewer/reviewed'},
			// {name: 'DONATION', link: 'reviewer/all'},
			// {name: 'SETTINGS', link: 'profile'},
			{name: 'SYSTEM'}
		],
		secondTabs: [
			{
				index: 0,
				tabs: [
					{name: 'HOME', link: 'site/home'},
					{name: 'STORY', link: 'site/story'},
					{name: 'FEATURES', link: 'site/features'},
					{name: 'PRICING', link: 'site/pricing'},
					{name: 'GET STARTED', link: 'site/getstarted'},
					{name: 'CONTACT', link: 'site/contact'}
				]
			},
			{
				index: 0,
				tabs: [
					// {name: 'ROSE THEATER', link: 'festival/venues'},
					{name: 'CONCIERGE', link: 'festival/concierge'},
					{name: 'BALLOTS', link: 'festival/ballots'},
					{name: 'NEXT UP', link: 'festival/nextup'},
					{name: 'PROGRAM', link: 'festival/program'},
					{name: 'FILMS', link: 'festival/films'},
					{name: 'FAVORITES', link: 'festival/favorites'},
					{name: 'TICKETS', link: 'festival/tickets'}
				]
			},
			{
				index: 0,
				tabs: [
					{name: 'LINEUP', link: 'program/lineup'},
					{name: 'LETTER', link: 'program/letter'},
					{name: 'BLOCK', link: 'program/block'},
					{name: 'GRID', link: 'program/grid'},
					{name: 'BALLOT', link: 'program/ballot'}
				]
			},
			{
				index: 0,
				tabs: [
					{name: 'RESULTS', link: 'reviewer/results'},
					{name: 'TEAM', link: 'reviewer/team'},
					{name: 'CONTENT', link: 'reviewer/content'},
					{name: 'AVAILABLE', link: 'reviewer/available'},
					{name: 'REVIEWING', link: 'reviewer/reviewing'},
					{name: 'REVIEWED', link: 'reviewer/reviewed'},
					{name: 'ALL', link: 'reviewer/all'},
					{name: 'CONTACTS', link: 'common/contacts'},
					// {name: 'SETTINGS', link: 'common/settings'},
					{name: 'PROFILE', link: 'common/profile'},
					{name: 'DEV', link: 'reviewer/dev'}
				]
			},
			{
				index: 0,
				tabs: [
					{name: 'ORGANIZATION', link: 'system/organization'},
					{name: 'EVENT', link: 'system/event'},
					{name: 'EMAIL', link: 'system/email'},
					{name: 'PRECONTENT', link: 'system/precontent'}
				]
			}
		]
	};



	navTabsReviewerOnly = {
		firstIndex: 0,
		firstTabs: [
			{name: 'REVIEWER'}
		],
		secondTabs: [
			{
				index: 0,
				tabs: [
					{name: 'AVAILABLE', link: 'reviewer/available'},
					{name: 'REVIEWING', link: 'reviewer/reviewing'},
					{name: 'REVIEWED', link: 'reviewer/reviewed'},
					{name: 'ALL', link: 'reviewer/all'},
					{name: 'PROFILE', link: 'common/profile'}
				]
			}
		]
	};


	navTabsReviewerOnlyWithoutAll = {
		firstIndex: 0,
		firstTabs: [
			{name: 'REVIEWER'}
		],
		secondTabs: [
			{
				index: 0,
				tabs: [
					{name: 'AVAILABLE', link: 'reviewer/available'},
					{name: 'REVIEWING', link: 'reviewer/reviewing'},
					{name: 'REVIEWED', link: 'reviewer/reviewed'},
// !!! TODO - PUT THIS BACK !!!
					// {name: 'ALL', link: 'reviewer/all'},
					{name: 'PROFILE', link: 'common/profile'}
				]
			}
		]
	};




	navTabs = {
		firstIndex: 3,
		firstTabs: [
			{name: 'SITE'},
			{name: 'FESTIVAL'},
			{name: 'PROGRAM'},
			{name: 'REVIEWER'},
			// {name: 'PASSES', link: 'reviewer/availalbe'},
			// {name: 'VOLUNTEER', link: 'reviewer/reviewing'},
			// {name: 'SPONSOR', link: 'reviewer/reviewed'},
			// {name: 'DONATION', link: 'reviewer/all'},
			// {name: 'SETTINGS', link: 'profile'},
			{name: 'SYSTEM'}
		],
		secondTabs: [
			{
				index: 0,
				tabs: [
					{name: 'HOME', link: 'site/home'},
					{name: 'STORY', link: 'site/story'},
					{name: 'FEATURES', link: 'site/features'},
					{name: 'PRICING', link: 'site/pricing'},
					{name: 'GET STARTED', link: 'site/getstarted'},
					{name: 'CONTACT', link: 'site/contact'}
				]
			},
			{
				index: 0,
				tabs: [
					// {name: 'ROSE THEATER', link: 'festival/venues'},
					{name: 'CONCIERGE', link: 'festival/concierge'},
					{name: 'BALLOTS', link: 'festival/ballots'},
					{name: 'NEXT UP', link: 'festival/nextup'},
					{name: 'PROGRAM', link: 'festival/program'},
					{name: 'FILMS', link: 'festival/films'},
					{name: 'FAVORITES', link: 'festival/favorites'},
					{name: 'TICKETS', link: 'festival/tickets'}
				]
			},
			{
				index: 0,
				tabs: [
					{name: 'LINEUP', link: 'program/lineup'},
					{name: 'LETTER', link: 'program/letter'},
					{name: 'BLOCK', link: 'program/block'},
					{name: 'GRID', link: 'program/grid'},
					{name: 'BALLOT', link: 'program/ballot'}
				]
			},
			{
				index: 0,
				tabs: [
					{name: 'RESULTS', link: 'reviewer/results'},
					{name: 'TEAM', link: 'reviewer/team'},
					{name: 'CONTENT', link: 'reviewer/content'},
					{name: 'AVAILABLE', link: 'reviewer/available'},
					{name: 'REVIEWING', link: 'reviewer/reviewing'},
					{name: 'REVIEWED', link: 'reviewer/reviewed'},
					{name: 'ALL', link: 'reviewer/all'},
					{name: 'CONTACTS', link: 'common/contacts'},
					// {name: 'SETTINGS', link: 'common/settings'},
					{name: 'PROFILE', link: 'common/profile'},
					{name: 'DEV', link: 'reviewer/dev'}
				]
			},
			{
				index: 0,
				tabs: [
					{name: 'ORGANIZATION', link: 'system/organization'},
					{name: 'EVENT', link: 'system/event'},
					{name: 'EMAIL', link: 'system/email'},
					{name: 'PRECONTENT', link: 'system/precontent'}
				]
			}
		]
	};
*/







	// isLoaded = false;

/*
	tabs = {
		'app.contacts': {
			name: 'Contacts',
			isVisible: true
		},
		'app.companies': {
			name: 'Companies',
			isVisible: true
		},
		'app.films': {
			name: 'Films',
			isVisible: true
		},


		'app.program.lineup': {
			name: 'Lineup',
			isVisible: true
		},
		'app.program.letter': {
			name: 'Letter',
			isVisible: true
		},
		'app.program.block': {
			name: 'Block',
			isVisible: true
		},
		'app.program.grid': {
			name: 'Grid',
			isVisible: true
		},
		'app.program.ballot': {
			name: 'Ballot',
			isVisible: true
		},





		'app.reviewer.program': {
			name: 'Lineup',
			isVisible: true
		},
		'app.reviewer.letter': {
			name: 'Letter',
			isVisible: true
		},
		'app.reviewer.block': {
			name: 'Block',
			isVisible: true
		},
		'app.reviewer.grid': {
			name: 'Grid',
			isVisible: true
		},
		'app.reviewer.ballot': {
			name: 'Ballot',
			isVisible: true
		},



		'app.reviewer.results': {
			name: 'Team',
			isVisible: true
		},
		'app.reviewer.team': {
			name: 'Team',
			isVisible: true
		},
		'app.reviewer.content': {
			name: 'Content',
			isVisible: true
		},
		'app.reviewer.available': {
			name: 'Available',
			isVisible: true
		},
		'app.reviewer.reviewing': {
			name: 'Reviewing',
			isVisible: true
		},
		'app.reviewer.reviewed': {
			name: 'Reviewed',
			isVisible: true
		},
		'app.reviewer.all': {
			name: 'All',
			isVisible: true
		},
		'app.reviewer.settings': {
			name: 'Settings',
			isVisible: true
		},
		'app.reviewer.dev': {
			name: 'Dev',
			isVisible: true
		},



		'app.system.organization': {
			name: 'Organization',
			isVisible: true
		},
		'app.system.event': {
			name: 'Event',
			isVisible: true
		},
		'app.system.email': {
			name: 'Email',
			isVisible: true
		},
		'app.system.precontent': {
			name: 'PreContent',
			isVisible: true
		},



		'app.common.contacts': {
			name: 'Profile',
			isVisible: true
		},
		'app.common.profile': {
			name: 'Profile',
			isVisible: true
		},



		'app.profile': {
			name: 'Profile',
			isVisible: true
		}
	};
*/



/*
	setVisibility(tabAuthName: string, isVisible: boolean) {
		// console.log('tabAuthName 1');
		// console.log(tabAuthName);
		let tab = this.tabs[tabAuthName];
		if (!tab) {
			this.log.error('unknown tab: ' + tabAuthName);
			return;
		}
		tab.isVisible = isVisible;

		let visibleTabsString = JSON.stringify(this.tabs);
		localStorage.setItem('visible-tabs', visibleTabsString);

		// update display of tabs
	}


	getVisibility(tabAuthName: string) {
		if (!this.isLoaded) {
			this.isLoaded = true;

			if (!window.localStorage) {
				console.log('Browser does not support local storage.');
				return;
			}

			let visibleTabsString = localStorage.getItem('visible-tabs');
			if (visibleTabsString) {
				this.tabs = JSON.parse(visibleTabsString);
			}
		}

		let tab = this.tabs[tabAuthName];
		// console.log('tabAuthName 2');
		// console.log(tabAuthName);
		if (!tab) {
			this.log.error('unknown tab: ' + tabAuthName);
			return;
		}
		return tab.isVisible;
	}




	getDisplayName(tabAuthName: string) {
		if (!this.isLoaded) {
			this.isLoaded = true;

			if (!window.localStorage) {
				console.log('Browser does not support local storage.');
				return;
			}

			let visibleTabsString = localStorage.getItem('visible-tabs');
			if (visibleTabsString) {
				this.tabs = JSON.parse(visibleTabsString);
			}
		}

		let tab = this.tabs[tabAuthName];
		// console.log('tabAuthName 3');
		// console.log(tabAuthName);
		if (!tab) {
			this.log.error('unknown tab: ' + tabAuthName);
			return;
		}
		return tab.name;
	}
*/

	private buildTabs() {

		// find fixed indexes
		this.navTabsFullSet.firstTabs.forEach((firstTab, firstTabIndex) => {
			if (firstTab.name === 'SITE') {
				this.siteIndex = firstTabIndex;
			}
			if (firstTab.name === 'REVIEWER') {
				this.reviewerIndex = firstTabIndex;
				firstTab.secondTab.tabs.forEach((secondTab, secondTabIndex) => {
					if (secondTab.name === 'PROFILE') {
						this.reviewerProfileIndex = secondTabIndex;
					}
				});
			}
			if (firstTab.name === 'VOLUNTEER') {
				this.volunteerIndex = firstTabIndex;
				firstTab.secondTab.tabs.forEach((secondTab, secondTabIndex) => {
					if (secondTab.name === 'VOLUNTEER APPLICATION') {
						this.volunteerApplicationIndex = secondTabIndex;
					}
				});
			}
		});

		// console.log('siteIndex = ' + this.siteIndex);
		// console.log('reviewerIndex = ' + this.reviewerIndex);
		// console.log('reviewerProfileIndex = ' + this.reviewerProfileIndex);
		// console.log('volunteerIndex = ' + this.volunteerIndex);
		// console.log('volunteerApplicationIndex = ' + this.volunteerApplicationIndex);


		this.permissionsString = this.getPermissionsString();

		let theTabs = null;


		// start with fresh copy
		// walk the list of visible tabs, remove as

		// hack attack for now!!


		if (window.localStorage) {
			let savedInfoString = localStorage.getItem('saved-info');
			if (savedInfoString) {
				let savedInfo = JSON.parse(savedInfoString);
				// console.log('buildTabs, savedInfo');
				// console.log(savedInfo);
				if (savedInfo && savedInfo.firstName) {
					this.navTabsFullSet.firstTabs[this.reviewerIndex].secondTab.tabs[this.reviewerProfileIndex].name = savedInfo.firstName.toUpperCase();
				}
			}
		}


		theTabs = JSON.parse(JSON.stringify(this.navTabsFullSet));

		if (theTabs && theTabs.firstTabs && this.authService.organizationId) {
			// console.log('buildTabs with auth');

			// before first, mark site and its tabs as auth'd and visible?
			theTabs.firstTabs[this.siteIndex].isAuth = true;
			theTabs.firstTabs[this.siteIndex].secondTab.tabs.forEach((secondTabDefinition) => {
				secondTabDefinition.isAuth = true;
			});


			// also, mark volunteer and its volunteerApplication as auth'd and visible?
			theTabs.firstTabs[this.volunteerIndex].isAuth = true;
			theTabs.firstTabs[this.volunteerIndex].secondTab.tabs[this.volunteerApplicationIndex].isAuth = true;
			// also, mark volunteer and its tabs as auth'd and visible?
			// theTabs.firstTabs[this.volunteerIndex].secondTab.tabs.forEach((secondTabDefinition) => {
			// 	secondTabDefinition.isAuth = true;
			// });


			// first, walk the list and mark what is auth'd
			// console.log('this.authService.userAuthorizations');
			// console.log(this.authService.userAuthorizations);

			// console.log('this.authService.organizationId');
			// console.log(this.authService.organizationId);

			Object.keys(this.authService.userAuthorizations).forEach((key) => {
				if (this.authService.userAuthorizations[key]) {
					let parts = key.split('.');
					if (parts.length > 2) {
						// console.log('authorized for key = ' + key);

						theTabs.firstTabs.forEach((firstTab) => {
							if (parts[1].toLowerCase() === 'common') {

								firstTab.secondTab.tabs.forEach((secondTabDefinition) => {
									if (parts[1].toLowerCase() + '/' + parts[2].toLowerCase() === secondTabDefinition.link.toLowerCase()) {
										secondTabDefinition.isAuth = true;
										// console.log('        secondTabDefinition auth, link = ' + secondTabDefinition.link.toLowerCase());
									}
								});
							} else {
								if (parts[1].toLowerCase() === firstTab.name.toLowerCase() ) {
									firstTab.isAuth = true;
									// console.log('    firstTab auth, name = ' + firstTab.name.toLowerCase());

									firstTab.secondTab.tabs.forEach((secondTabDefinition) => {
										if (parts[1].toLowerCase() + '/' + parts[2].toLowerCase() === secondTabDefinition.link.toLowerCase()) {
											secondTabDefinition.isAuth = true;
											// console.log('        secondTabDefinition auth, link = ' + secondTabDefinition.link.toLowerCase());
										}
									});
								}
							}
						});
					}
				}
			});

			// !!! TODO - Bug, when walking, if db has firstTab but there is no matching secondTab for that firstTab don't mark auth'd
			// festival/tickets versus festival/ticket

			// next, walk the list and mark what is visible

			// finally, rebuild obj only for those that are auth'd and visible
			let newTabs: any = {};
			newTabs.firstIndex = theTabs.firstIndex;
			newTabs.firstTabs = [];

			theTabs.firstTabs.forEach((firstTab) => {
				if (firstTab.isAuth) {
					let newFirstTab: any = {};
					newFirstTab.name = firstTab.name;
					newFirstTab.secondTab = {};
					newFirstTab.secondTab.index = firstTab.secondTab.index;
					newFirstTab.secondTab.tabs = [];

					firstTab.secondTab.tabs.forEach((secondTabDefinition) => {
// console.log('secondTabDefinition.isAuth');
// console.log(firstTab.name + ' ' + secondTabDefinition.name);
// console.log(secondTabDefinition.isAuth);
						if (secondTabDefinition.isAuth) {
							let newSecondTabDefinition: any = {};
							newSecondTabDefinition.name = secondTabDefinition.name;
							newSecondTabDefinition.link = secondTabDefinition.link;
							newFirstTab.secondTab.tabs.push(newSecondTabDefinition);
						}
					});

					newTabs.firstTabs.push(newFirstTab);
				}
			});



			// console.log('newTabs');
			// console.log(newTabs);
			// console.log(JSON.stringify(newTabs, null, 2) );





			// this.navTabs = theTabs;
			this.navTabs = newTabs;
			// console.log('buildTabs with auth');
		} else {
			// console.log('buildTabs without auth');
			this.navTabs = this.navTabsSiteOnly;
		}
		// console.log('this.navTabs');
		// console.log(this.navTabs);
		// console.log(JSON.stringify(this.navTabs, null, 2) );



		this.newTabsSource.next(this.navTabs);
	}


	setProfileName() {
		this.buildTabs();
	}


	updateTabsByRoute(selectedRoute: string) {
		if (selectedRoute.length === 0) {
			// console.log('#1 empty selectedRoute');
			return;
		}

		let parts = selectedRoute.split('/');
		if (parts.length < 3) {
			// this.log.error('updateTabIndexesByRoute, invalid selectedRoute split, selectedRoute = ' + selectedRoute);
			return;
		}

		let currentPermissionsString = this.getPermissionsString();
		if (currentPermissionsString !== this.permissionsString) {
			// console.log('updateTabIndexesByRoute, found new permissions string!!!  currentPermissionsString = ' + currentPermissionsString);
			this.buildTabs();
		}
		this.updateTabIndexesByRoute(selectedRoute);
	}


	private updateTabIndexesByRoute(selectedRoute: string) {
		if (selectedRoute.length === 0) {
			// console.log('#2 empty selectedRoute');
			return;
		}

		if (!this.navTabs || !this.navTabs.firstTabs) {
			this.log.error('updateTabIndexesByRoute, invalid this.navTabs');
			return;
		}
		if (!selectedRoute) {
			this.log.error('updateTabIndexesByRoute, invalid selectedRoute');
			return;
		}
		let parts = selectedRoute.split('/');
		if (parts.length < 3) {
			this.log.error('updateTabIndexesByRoute, invalid selectedRoute split, selectedRoute = ' + selectedRoute);
			return;
		}

		let firstIndex = this.navTabs.firstTabs.findIndex((firstTab) => {
			if ((firstTab.name.toLowerCase() === 'reviewer') && (parts[1].toLowerCase()) === 'common') {
				// special case for profile and contacts, they live in common, but display on reviewer
				// console.log('found reviewer common');
				return true;
			}
			return (firstTab.name.toLowerCase() === parts[1].toLowerCase());
		});
		if (firstIndex === -1) {
			firstIndex = 0;
		}

		let secondIndex = this.navTabs.firstTabs[firstIndex].secondTab.tabs.findIndex((secondTab) => {
			return (secondTab.link.toLowerCase() === parts[1].toLowerCase() + '/' + parts[2].toLowerCase());
		});
		if (secondIndex === -1) {
			secondIndex = 0;
		}

		// console.log('firstIndex');
		// console.log(firstIndex);
		// console.log('secondIndex');
		// console.log(secondIndex);

		this.navTabs.firstIndex = firstIndex;
		this.navTabs.firstTabs[firstIndex].secondTab.index = secondIndex;
	}


	private getPermissionsString() {
		let permissions = JSON.stringify(this.authService.userAuthorizations);
		// console.log('permissions = ');
		// console.log(permissions);
		return permissions;
	}
}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/tab.service.ts